<script setup lang="ts">
import { brand } from '../config/brand'

const props = defineProps<{
  withBase: (p: string) => string
}>()
</script>

<template>
  <footer class="siteFooter">
    <div class="container">
      <div class="footerGrid">
        <div class="footerBrand">
          <img class="footerLogo" :src="props.withBase(brand.logoPath)" :alt="brand.productName" width="48" height="48" />
          <div>
            <strong>{{ brand.productName }}</strong>
            <span>{{ brand.slogan }}</span>
          </div>
        </div>

        <div class="footerMenus" aria-label="页脚菜单">
          <div class="footerCol">
            <h4>工作流</h4>
            <ul>
              <li><a href="/ai-workbench/">{{ brand.workbenchName }}</a></li>
            </ul>
          </div>
          <div class="footerCol">
            <h4>视频AI</h4>
            <ul>
              <li><a href="/ai-workbench/tools/?tool=removeWatermark_vid&embed=1">视频去水印</a></li>
              <li><a href="/ai-workbench/tools/?tool=removeText_vid&embed=1">视频去字幕</a></li>
              <li><a href="/ai-workbench/tools/?tool=upscale_vid&embed=1">视频转高清</a></li>
              <li><a href="/ai-workbench/tools/?tool=eraseObject_vid&embed=1">万能视频消除</a></li>
            </ul>
          </div>
          <div class="footerCol">
            <h4>图像AI</h4>
            <ul>
              <li><a href="/ai-workbench/tools/?tool=remove_pic&embed=1">万能图片消除</a></li>
            </ul>
          </div>
          <div class="footerCol">
            <h4>资源</h4>
            <ul>
              <li><a href="/user-agreement/">用户协议</a></li>
              <li><a href="/privacy/">隐私政策</a></li>
              <li><a href="/refund-policy/">退款协议</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footerCopyright">Copyright ©2026 {{ brand.productName }} | 杭州岁羽网络科技有限公司 | 浙ICP备2024067080号</div>
    </div>
  </footer>
</template>
